module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="headline-wrapper">\n    <h4 class="action">'+
((__t=(t('collection::objects:list:add-button')))==null?'':_.escape(__t))+
'</h4>\n</div>\n<span class="empty-plus" data-action="add-object">+</span>';
}
return __p;
};